/* eslint-disable react-hooks/exhaustive-deps */
import React, {FC, useEffect, useState} from 'react'
import {Dropdown, FormControl, OverlayTrigger, Tooltip} from 'react-bootstrap'
import {getListEconMember} from '../../app/pages/national/fta-impact/core/_requests'
import useAxiosPrivate from '../../app/libs/useAxiosPrivate'

type EconDropdownProps = {
  onSelect: (econ: any) => void
  disabled?: boolean
  econ?: string
}

type selectedEconType = {
  economy: string
  iso3: string
  iso2: string
}

const EconDropdown: FC<EconDropdownProps> = ({onSelect, disabled = false, econ}) => {
  const axiosPrivate = useAxiosPrivate()
  const [economies, setEconomies] = useState<Array<any> | null>([])
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [selectedEcon, setSelectedEcon] = useState<selectedEconType>()
  const [filteredEcon, setFilteredEcon] = useState<Array<any>>([])

  useEffect(() => {
    getListEconMember(axiosPrivate)
      .then((res) => {
        setEconomies(res.data.econ)
        setFilteredEcon(res.data.econ)
        // if (econ) {
        //   setSelectedEcon(res.data.econ.find((data) => data.iso3 === econ))
        // }
      })
      .catch((e) => {
        console.error(e)
      })
  }, [])

  useEffect(() => {
    setFilteredEcon(filteredEcon!)
  }, [filteredEcon, econ])

  useEffect(() => {
    if (!econ) {
      setSelectedEcon(undefined)
      return
    }

    const found = economies?.find((e) => e.iso3 === econ)
    setSelectedEcon(found)
  }, [econ, economies])

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    setSearchTerm(value)
    const filteredEcon = economies?.filter((econ) =>
      econ.economy.toLowerCase().includes(value.toLowerCase())
    )
    setFilteredEcon(filteredEcon!)
  }

  const removeSearchTerm = () => {
    setSearchTerm('')
    setFilteredEcon(economies!)
  }

  const handleSelect = (econ: any) => {
    onSelect(econ.iso3)
    setSelectedEcon(econ)
  }

  const dropdownItem = filteredEcon?.map((econ) => {
    return (
      // <OverlayTrigger
      //   key={econ.iso2.toLowerCase()}
      //   placement="right"
      //   overlay={<Tooltip id={`tooltip-${econ.iso2.toLowerCase()}`}>{econ.economy}</Tooltip>}
      //   container={document.body}
      //   >
      <Dropdown.Item
        key={econ.iso2.toLowerCase()}
        role='menuitem'
        size='sm'
        onClick={() => handleSelect(econ)}
        title={econ.economy}
      >
        <span className={`fi fi-${econ.iso2.toLowerCase()} me-2`}></span> {econ.economy}
      </Dropdown.Item>
      // </OverlayTrigger>
    )
  })

  return (
    <Dropdown className='pt-2' onToggle={removeSearchTerm}>
      <Dropdown.Toggle
        variant='label-dropdown'
        id=''
        className='btn btn-sm btn-bold dropdown-toggle fw-normal text-start w-100'
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
        disabled={disabled}
      >
        {selectedEcon ? (
          <div
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'clip',
              maxWidth: '200px',
            }}
          >
            <span className={`fi fi-${selectedEcon.iso2.toLowerCase()} me-2`}></span>{' '}
            {selectedEcon.economy}
          </div>
        ) : (
          'Select Country'
        )}
      </Dropdown.Toggle>
      <Dropdown.Menu className='dropdown-econ-menu'>
        <FormControl
          type='text'
          size='sm'
          placeholder='Search...'
          className='dropdown-econ-search-bar'
          value={searchTerm}
          onChange={handleSearch}
          style={{}}
        />
        {dropdownItem}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default EconDropdown
